module.exports = __webpack_public_path__ + "img/Mary Moore.cdee5042.jpg";